/**
 * Creates a Promise that can be resolved externally.
 *
 * @return {Promise}
 *         A Promise that can be externally resolved or rejected.
 */
export function defer() {

    let res = () => {};
    let rej = () => {};

    const promise = new Promise((resolve, reject) => {
        res = resolve;
        rej = reject;
    });

    promise.resolve = (value) => {
        res(value);
        return promise;
    };

    promise.reject = (reason) => {
        rej(reason);
        return promise;
    };

    return promise;

}

/**
 * Creates a Promise that resolves the first time the given event is triggered
 * on the observer, with the value picked from the event's detail.
 *
 * @param  {Observer} observer
 *         Observer to listen to.
 * @param  {String} eventName
 *         Name of the event to wait for.
 * @param  {String} key
 *         Key on the event's detail to resolve with.
 * @return {Promise}
 *         A Promise resolving with the detail value.
 */
export function once(observer, eventName, key) {

    return new Promise((resolve) => {
        observer.on(eventName, ({ detail }) => resolve(detail[key]));
    });

}
